<template>
  <div id="personal-profile-address-tab-id">
    <div class="custom-tab">
      <b-tabs card>
        <div v-for="(address, index) in addresses" :key="index">
          <b-tab :title="address.address_type"
              @click.prevent="setDetailCurrentTab(`#${address.address_type.toLowerCase()}_address`, 'personal-profile-address-tab-id')"
              :active="getDetailActiveTab === `${address.address_type.toLowerCase()}_address`">
            <person-address-detail :addressObject="address" />
          </b-tab>
        </div>
        <b-tab title="All"
        @click.prevent="setDetailCurrentTab('#all_addresses', 'personal-profile-address-tab-id')"
        :active="getDetailActiveTab === 'all_addresses'"
        >
          <div v-for="(address, index) in addresses" :key="index">
            <span :class="`px-2 mb-2 ml-3 badge ${preferred_address_type === address.address_type ? 'badge-primary' : 'badge-secondary'}`">
              <span class="regular-16 typo-color-white">
                {{ address.address_type }}
              </span>
            </span>
            <person-address-detail :addressObject="address" />
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import mixin from '@/utils/mixin.js'
import PersonAddressDetail from './PersonAddressDetail.vue'
import { mapGetters } from 'vuex'

export default {
  name: "PersonAddress",
  components: { PersonAddressDetail },
  props: ['addresses', "preferred_address_type"],
  data () {
    return {
      tabs: ['#home_address',
      '#work_address',
      '#all_addresses']
    }
  },
  computed: {
    ...mapGetters(['getDetailActiveTab']),
  },
  methods: {
    formatAddresses(address) {
      return [
        address.street1,
        address.street2,
        `${address.city}, ${address.state} ${address.zip_code}`,
        address.country_name
      ]
    }
  },
  mixins: [mixin],
  mounted () {
    if(this.tabs.indexOf(this.$route.hash) !== -1) {
      var hashPath = this.$route.hash
      this.setDetailCurrentTab(hashPath.substring(1), 'personal-profile-address-tab-id')
    }
  },
}
</script>
